/**
 * imgUrl: 图片url
 * isCanDel: 是否显示删除按钮
 * changeImgUrl: 接受上传后图片的最新url
 */
import React, { Component } from 'react';
import { Upload, Icon, message, Modal, notification, Tag } from 'antd';
import Api from '@/services';
import styles from './index.less';
function beforeUpload(file) {
    const isLt5M = file.size / 1024 / 1024 < 5;
    if (!isLt5M) {
        message.error('上传的图片不超过5MB');
    }
    return isLt5M;
}
export default class UploadImg extends Component {
    constructor(props) {
        super(props);
        // 组件标示，防止内存泄漏
        this._isMounted = false;
        // 图片上传
        this.handleChange = (info) => {
            this._isMounted = true;
            this.setState({ loading: true });
            const formData = new FormData();
            formData.append('file', info.file);
            Api.base.uploadImage(formData).then((res) => {
                this.props.changeImgUrl(res);
                this._isMounted && this.setState({ loading: false });
            }).catch((err) => {
                this.props.changeImgUrl('');
                this._isMounted && this.setState({ loading: false });
                notification.error({
                    message: '图片上传失败',
                    description: '图片上传失败,请重试',
                });
            });
        };
        // 取消预览
        this.handleCancel = () => this.setState({ previewVisible: false });
        // 查看预览
        this.handlePreview = () => {
            this.setState({
                previewImage: this.props.imgUrl,
                previewVisible: true,
            });
        };
        // 重新上传
        this.handleReUpload = () => {
            this.props.changeImgUrl('');
        };
        this.state = {
            loading: false,
            previewVisible: false,
            previewImage: '',
        };
    }
    componentWillUnmount() {
        console.log('我被卸载了');
        this._isMounted = false;
    }
    render() {
        const { isCanDel, imgUrl, disabled = false, isImageDafault = false } = this.props;
        const { loading, previewVisible, previewImage } = this.state;
        return (<React.Fragment>
        {imgUrl ?
            <div className={styles.upload_img_container}>
              {isImageDafault && <Tag color="#f50" className={styles.default_Icon}>默认</Tag>}
              <img src={imgUrl} className={styles.imgStyle}/>
              <div className={styles.operate_container}>
                <span onClick={this.handlePreview}><Icon type="eye" className={styles.icon}/></span>
                {isCanDel && <span onClick={this.handleReUpload}><Icon type="delete" className={styles.icon}/></span>}
              </div>
            </div>
            :
                <Upload name="file" accept="image/*" listType="picture-card" className="avatar-uploader" disabled={disabled} showUploadList={false} beforeUpload={beforeUpload} customRequest={this.handleChange}>
              <div>
                <Icon type={loading ? 'loading' : 'plus'}/>
                <div className="ant-upload-text">点击上传</div>
              </div>
            </Upload>}
        <Modal visible={previewVisible} footer={null} onCancel={this.handleCancel}>
          <img alt="example" style={{ width: '100%' }} src={previewImage}/>
        </Modal>
      </React.Fragment>);
    }
}
